import { pickBy, isNil } from "lodash";
import qs from "qs";
import axios from "common/axios";
import { message } from "antd";

// 转换成...
export const formatEllipse = (text, size = 6) => {
  let stringText = String(text);
  if (stringText.length > size) {
    return stringText.slice(0, size - 1) + "...";
  } else {
    return text;
  }
};

// 滚动容器获取
export const getScrollContainer = () => {
  // 如果跳转到login页面，然后跳转回来，就会存在找不到container问题
  return document.getElementById("scroll-container");
};
// 滚动main获取
export const getScrollBox = () => {
  // 如果跳转到login页面，然后跳转回来，就会存在找不到container问题
  return document.getElementById("scroll-box");
};
/**
 * @description: 获取用户信息
 * @param {*}
 * @return {*}
 */
export function getUserInfo() {
  return JSON.parse(sessionStorage.getItem("userInfo") || localStorage.getItem("userInfo") || "{}") || {};
}

// 文件下载
export function downloadHandle(res, name) {
  // 文件流
  if (res.type === "application/octet-stream") {
    try {
      const blob = new Blob([res], {});
      const link = Object.assign(document.createElement("a"), {
        href: URL.createObjectURL(blob),
        download: name, //下载的文件名
      });
      link.click();
    } catch (e) {
      console.error("处理下载请求失败, 错误原因:\n", res);
    }
  } else {
    message.error(res.message || "服务器处理错误，下载失败");
  }
}

/**
 * @description: 文件下载
 * 跨域链接无法获取错误信息
 * 暂时处理get请求的，暂时不完善
 * @param {*} url
 * @return {*}
 */
export function downloadFile({ url, method = "get" }) {
  let iframe = document.createElement("iframe");
  const iframeName = `iframe-${Math.random()}`;

  Object.assign(iframe, {
    name: iframeName,
    id: iframeName,
    onload: (e) => {
      const { contentWindow } = iframe;
      // 如果报错时，可以获得报错内容
      const errorInfo = contentWindow?.document.getElementsByTagName("pre")[0]
        ?.textContent;
      if (errorInfo) {
        try {
          const res = JSON.parse(errorInfo);
          message.error(res.message || "下载失败");
        } catch (e) {
          message.error(errorInfo);
        }
      }
      // 延迟删除，以免请求还未返回就已经卸载了
      const timmer = setTimeout(() => {
        const findIframe = document.getElementById(iframe);
        if (findIframe) {
          document.body.removeChild();
        }
        clearTimeout(timmer);
      }, 5000);
    },
  });
  document.body.appendChild(iframe);

  const link = document.createElement("a");
  Object.assign(link, {
    target: iframeName,
    href: `''/${url}`,
  });
  link.click();
}

/**
 * json to url
 * @param {*}} params
 */
export function jsonToUrl(params, options = {}) {
  const { filterNil = true } = options;
  let paramsTemp = params;
  if (filterNil) {
    paramsTemp = pickBy(params, (value) => !isNil(value) && value !== "");
  }
  return qs.stringify(paramsTemp, {
    encode: false,
    arrayFormat: "comma",
    addQueryPrefix: true,
    ...options,
  });
}

/**
 * 获取查询参数
 * @param {*} url
 */
export function getQueryParams(url, options = {}) {
  return qs.parse(url, { ignoreQueryPrefix: true, ...options });
}

export const getCountry = async (call) => {
  const res = await axios.get("/tools/country/list", {
    // params: { noAuthorization: true },
  });
  console.log(res, "---guojia---");
  // const result = res?.data;
  if (res?.body) {
    sessionStorage.setItem("Country", JSON.stringify(res.body ?? {}));
  }
  call && call(res?.body);
};

// 阻止冒泡
export function cancelBubble(e) {
  e.stopPropagation()
  e.nativeEvent.stopImmediatePropagation()
};
